<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title>Add User</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>
        <mat-card-content>
            <div [formGroup]="addUserForm">
                <mat-accordion>
                    <mat-expansion-panel formArrayName="model"
                        *ngFor="let item of addUserForm.get('model')['controls'];let i=index;first as isFirst"
                        [expanded]="isFirst" style="background-color:beige;">
                        <mat-expansion-panel-header>
                            <mat-panel-title><mat-icon>account_circle</mat-icon></mat-panel-title>
                            <mat-panel-description>#{{i + 1}}</mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-card appearance="outlined">
                            <mat-card-content>
                                <div [formGroupName]="i">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>Employee ID</mat-label>
                                                <input matInput type="text" formControlName="employeeId" 
                                                placeholder="Employee ID" autocomplete="off" maxlength="20">
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('employeeId').hasError('required')">
                                                  Employee ID is required.
                                                </mat-error>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('employeeId').hasError('pattern')">
                                                  Employee ID must be alphanumeric with no special characters.
                                                </mat-error>
                                                  <mat-error *ngIf="addUserForm.get('model').controls[i].get('employeeId').hasError('maxlength')">
                                                  EmployeeId cannot be more than 20 characters.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>First Name</mat-label>
                                                <input matInput type="text" formControlName="firstName" placeholder="First Name" 
                                                autocomplete="off" maxlength="20">
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('firstName').hasError('required')">
                                                  First Name is required.
                                                </mat-error>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('firstName').hasError('pattern')">
                                                  First Name must only contain letters, spaces, and period.
                                                </mat-error>
                                                 <mat-error *ngIf="addUserForm.get('model').controls[i].get('firstName').hasError('maxlength')">
                                                  First name cannot be more than 20 characters.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>Last Name</mat-label>
                                                <input matInput type="text" formControlName="lastName" placeholder="Last Name" 
                                                autocomplete="off" maxlength="20">
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('lastName').hasError('required')">
                                                  Last Name is required.
                                                </mat-error>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('lastName').hasError('pattern')">
                                                  Last Name must only contain letters, spaces, and period.
                                                </mat-error>
                                                 <mat-error *ngIf="addUserForm.get('model').controls[i].get('lastName').hasError('maxlength')">
                                                  Last name cannot be more than 20 characters.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                      <!-- Email Field -->
                                    <div class="row">
                                        <div class="col-md-6">
                                                <mat-form-field appearance="fill" color="accent">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput type="email" formControlName="email" placeholder="Email" autocomplete="off">
                                                    <mat-error *ngIf="addUserForm.get('model').controls[i].get('email').hasError('required')">
                                                    Email is required.
                                                    </mat-error>
                                                    <mat-error *ngIf="addUserForm.get('model').controls[i].get('email').hasError('invalidEmail')">
                                                                 {{ addUserForm.get('model').controls[i].get('email').getError('invalidEmail') }}
                                                    </mat-error>
                                                </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                             <!-- Mobile Number Field -->
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>Mobile Number</mat-label>
                                                <input matInput type="text" required formControlName="phoneNumber" 
                                                placeholder="Mobile Number" maxlength="10"
                                                 autocomplete="off" >
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('phoneNumber').hasError('required')">
                                                  Mobile Number is required.
                                                </mat-error>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('phoneNumber').hasError('pattern')">
                                                  Mobile Number must be a 10-digit number.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                    <!-- Status Field -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="appStatusId">
                                                  <mat-option [value]="null">Select a status</mat-option>
                                                  <mat-option *ngFor="let status of userStatus" [value]="status.appStatusId">
                                                    {{ status.status }}
                                                  </mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('appStatusId').hasError('required')">
                                                  Status is required.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                             <!-- Role Field -->
                                             <mat-form-field appearance="fill" color="accent">
                                                <mat-label>Role</mat-label>
                                                <mat-select formControlName="roleId">
                                                  <mat-option [value]="null">Select a role</mat-option>
                                                  <mat-option *ngFor="let role of roles" [value]="role.roleId">{{ role.roleName }}</mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('roleId').hasError('required')">
                                                  Role is required.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <!-- State Field -->
                                            <mat-form-field *ngIf="states.length > 0">
                                                <mat-label>State</mat-label>
                                                <mat-select [placeholder]="'States'"
                                                    (selectionChange)="onSelectionchange($event)"
                                                    formControlName="stateId">
                                                    <mat-form-field>
                                                        <input matInput type="text"
                                                            (keyup)="search($event.target.value)"
                                                            placeholder="search state">
                                                    </mat-form-field>
                                                    <mat-divider></mat-divider>
                                                    <mat-option *ngFor="let state of selectedStates; let i = index;"
                                                        [value]="state.stateId">
                                                        {{state.stateName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('stateId').hasError('required')">
                                                    State is required.
                                                  </mat-error>
                                            </mat-form-field>
                                        </div>
                                         <!-- City Field -->
                                        <div class="col-md-5">
                                            <mat-form-field appearance="fill" color="accent">
                                                <mat-label>City</mat-label>
                                                <mat-select formControlName="cityId">
                                                  <mat-option [value]="null">Select a city</mat-option>
                                                  <mat-option *ngFor="let city of cities" [value]="city.cityId">{{ city.cityName }}</mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="addUserForm.get('model').controls[i].get('cityId').hasError('required')">
                                                  City is required.
                                                </mat-error>
                                              </mat-form-field>
                                        </div>
                                        <div class="col-md-2 align-content-center">
                                            <mat-label style="color: #0000">-----------</mat-label>
                                            <button mat-mini-fab color="red;" style="margin:auto;"
                                                (click)="deleteGroup(i)" [disabled]="i === 0"
                                                aria-label="Delete current Form">
                                                <mat-icon>remove_from_queue</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="row action-btn justify-content-between" style="margin-top: 20px;">
                    <div class="col-md-4">
                        <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                            (click)="goBack()">User Management Home
                        </button>
                    </div>
                    <div class="col-md-4">
                        <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                            (click)="addItem()" [disabled]="!addUserForm.valid">Add New User</button>
                    </div>
                    <div class="col-md-4">
                        <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                            (click)="saveUser()" [disabled]="!addUserForm.valid">Save</button>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoaderResult" class="custSpinner"></div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>